export interface Topic {
  title: string;
  count: string;
}

export const heroStats = [
  { value: '12万+', label: '注册料友' },
  { value: '8600+', label: '看料心得帖' },
  { value: '58万+', label: '累计互动讨论' },
  { value: '4.8分', label: '社区互动口碑' },
];

export const hotTopics: Topic[] = [
  { title: '# 古装剧演技细品', count: '3.2万热度' },
  { title: '# 新手游戏避坑指南', count: '2.8万热度' },
  { title: '# 年度数码好物盘点', count: '2.4万热度' },
  { title: '# 上班族副业真实心得', count: '2.1万热度' },
  { title: '# 纪录片入坑安利', count: '1.7万热度' },
  { title: '# 老剧重刷才懂', count: '1.5万热度' },
  { title: '# 程序员转行感悟', count: '1.2万热度' },
  { title: '# 小众综艺挖宝', count: '0.9万热度' },
];

export interface Category {
  icon: string;
  name: string;
  desc: string;
  postCount: string;
}

export const categories: Category[] = [
  { icon: 'ri-clapperboard-line', name: '影剧综艺', desc: '追剧看片观后感、演技细节与剧情讨论', postCount: '2160+ 心得' },
  { icon: 'ri-gamepad-line', name: '游戏电竞', desc: '新游试玩、通关心得与上分避坑经验', postCount: '1890+ 心得' },
  { icon: 'ri-computer-line', name: '数码科技', desc: '新品实测、参数解读与使用真实感受', postCount: '1420+ 心得' },
  { icon: 'ri-briefcase-4-line', name: '职场成长', desc: '求职转行、副业副利与办公效率心得', postCount: '1180+ 心得' },
  { icon: 'ri-cup-line', name: '生活杂谈', desc: '生活方式、美食探店与日常真实分享', postCount: '2050+ 心得' },
  { icon: 'ri-history-line', name: '历史人文', desc: '历史冷知识、人文见闻与内容挖料', postCount: '900+ 心得' },
];

export interface Article {
  tag: string;
  tagColor: string;
  title: string;
  excerpt: string;
  author: string;
  time: string;
  comments: string;
  likes: string;
  image: string;
  alt: string;
}

export const articles: Article[] = [
  {
    tag: '影剧综艺',
    tagColor: 'primary',
    title: '把一部剧反反复复看三遍，我终于读懂了那些台词',
    excerpt: '第一遍看剧情，第二遍看演技，第三遍才真正注意到台词背后的伏笔与人物成长。分享一下我反复重刷一部剧之后的看料体会……',
    author: '阿晚',
    time: '昨天 21:40',
    comments: '132',
    likes: '864',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20cozy%20evening%20scene%20of%20a%20person%20watching%20a%20period%20drama%20on%20a%20screen%2C%20soft%20coral%20and%20cream%20toned%20interior%2C%20steaming%20tea%20and%20warm%20blanket%2C%20cinematic%20atmosphere%2C%20minimal%20editorial%20illustration%20style%20with%20soft%20shadows%2C%20friendly%20and%20relatable%20mood&width=800&height=560&seq=kanliao-art-01&orientation=landscape',
    alt: '夜晚窝在沙发反复重刷古装剧看料感受',
  },
  {
    tag: '游戏电竞',
    tagColor: 'accent',
    title: '入坑大作前先看这几点，新手少走三年弯路',
    excerpt: '很多朋友兴致勃勃买下热门大作却很快弃坑，其实大多是期望管理出了问题。这篇把我从萌新到老玩家的经验一次性讲透……',
    author: '老K',
    time: '2天前 14:12',
    comments: '210',
    likes: '1203',
    image: 'https://readdy.ai/api/search-image?query=A%20young%20gamer%20at%20a%20desk%20with%20a%20colorful%20game%20screen%20and%20controller%2C%20mint%20teal%20and%20warm%20peach%20lighting%2C%20clean%20desk%20setup%2C%20cozy%20modern%20room%2C%20minimal%20editorial%20illustration%20with%20soft%20tones%2C%20friendly%20beginner%20community%20mood&width=800&height=560&seq=kanliao-art-02&orientation=landscape',
    alt: '游戏新手在电脑前试玩热门大作的看料经验',
  },
  {
    tag: '数码科技',
    tagColor: 'secondary',
    title: '换新机三周，说说那些参数表上看不到的真实感受',
    excerpt: '参数测评看再多，不如上手用一阵子。续航焦虑、发热、手感、系统细节，这些才是决定要不要下单的关键，这篇如实交代……',
    author: '拾光',
    time: '3天前 09:30',
    comments: '98',
    likes: '756',
    image: 'https://readdy.ai/api/search-image?query=A%20close%20view%20of%20modern%20smartphone%20and%20headphones%20on%20a%20warm%20sandy%20desk%2C%20soft%20golden%20light%2C%20minimal%20product%20photography%20with%20clean%20cream%20background%2C%20amber%20and%20peach%20accent%20tones%2C%20editorial%20style%2C%20high%20detail%2C%20subtle%20shadows&width=800&height=560&seq=kanliao-art-03&orientation=landscape',
    alt: '桌上手机与耳机数码好物的真实使用体验分享',
  },
  {
    tag: '职场成长',
    tagColor: 'primary',
    title: '做副业半年才想明白：比努力更重要的，是先把料看准',
    excerpt: '很多人问我副业怎么起步，我都会先反问一句：你花多少时间先「看料」研究方向和市场？方向错了，越努力越偏……',
    author: '小鹿',
    time: '4天前 16:05',
    comments: '176',
    likes: '980',
    image: 'https://readdy.ai/api/search-image?query=A%20person%20working%20on%20a%20laptop%20with%20research%20notes%20and%20coffee%20at%20a%20warm%20desk%2C%20coral%20and%20cream%20palette%2C%20notebook%20and%20planner%20in%20view%2C%20soft%20natural%20window%20light%2C%20minimal%20flat%20illustration%20style%2C%20ambitious%20yet%20calm%20mood&width=800&height=560&seq=kanliao-art-04&orientation=landscape',
    alt: '整理资料研究副业方向的职场成长心得',
  },
  {
    tag: '生活杂谈',
    tagColor: 'accent',
    title: '连续探店一周，我总结了本地好吃不踩雷的挑店心得',
    excerpt: '避开营销号滤镜，从排队节奏、菜单结构到后厨动向，分享普通人也能用的选店看料小技巧，周末约饭不再两眼一抹黑……',
    author: '荔枝',
    time: '5天前 20:18',
    comments: '145',
    likes: '1102',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20table%20of%20delicious%20local%20food%20dishes%20with%20chopsticks%20and%20warm%20ambient%20light%2C%20cream%20and%20peach%20toned%20restaurant%20background%2C%20appetizing%20food%20photography%2C%20soft%20warm%20tone%2C%20editorial%20lifestyle%20style%2C%20inviting%20community%20sharing%20mood&width=800&height=560&seq=kanliao-art-05&orientation=landscape',
    alt: '本地美食探店挑选技巧的生活看料心得',
  },
  {
    tag: '历史人文',
    tagColor: 'secondary',
    title: '一个藏在老纪录片里的细节，让我重新理解了历史',
    excerpt: '周末偶然翻到一部冷门老纪录片，里面一个不经意的镜头却改变了我对某个历史事件的理解。看料最迷人的，往往就在这些意外……',
    author: '鹤归',
    time: '1周前 11:26',
    comments: '87',
    likes: '689',
    image: 'https://readdy.ai/api/search-image?query=A%20vintage%20documentary%20film%20aesthetic%20with%20old%20books%20maps%20and%20a%20warm%20reading%20lamp%2C%20soft%20amber%20and%20sand%20tones%2C%20nostalgic%20warm%20atmosphere%2C%20stacked%20vintage%20books%20and%20globe%2C%20editorial%20illustration%20with%20grainy%20texture%2C%20contemplative%20mood&width=800&height=560&seq=kanliao-art-06&orientation=landscape',
    alt: '翻阅历史书籍观看老纪录片的人文看料体会',
  },
];

export interface Member {
  name: string;
  role: string;
  quote: string;
  avatarText: string;
  avatarColor: string;
}

export const memberQuotes: Member[] = [
  {
    name: '芒果布丁',
    role: '入社 1 年 · 影剧区常客',
    quote: '以前追完一部剧总觉得自己没看明白，来了看料社才发现原来那么多人跟我一样纠结细节。现在追完剧先来这里找人聊，体验完全不同。',
    avatarText: '芒',
    avatarColor: 'primary',
  },
  {
    name: '码农小林',
    role: '入社 8 个月 · 数码科技区',
    quote: '我在这认识了几个真懂行的朋友，买设备前先发帖问一圈，避雷效率超高。看料社的氛围比那些只会抬杠的地方舒服太多了。',
    avatarText: '林',
    avatarColor: 'accent',
  },
  {
    name: '晚风',
    role: '入社 2 年 · 老玩家',
    quote: '在这当了两年「老手」，时不时也回萌新的帖子补几句经验。能把自己踩过的坑讲给需要的人听，本身就是一种收获。',
    avatarText: '风',
    avatarColor: 'secondary',
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '看料社是什么类型的网站？',
    a: '看料社是一个围绕各类兴趣内容的看料心得与经验分享互动讨论社区。大家在这里交流追剧、游戏、数码、职场、生活、历史人文等内容的真实感受，畅所欲言地讨论热门话题，分享自己的看法。',
  },
  {
    q: '我算是新手，来这里会不会跟不上？',
    a: '完全不会。看料社鼓励人人畅所欲言，既有老玩家的经验帖，也有大量给新手的入门指南。新手可以直接发帖提问，社区里的料友都很乐意交流，来了就能找到同好一起聊。',
  },
  {
    q: '发表看料心得需要注册账号吗？',
    a: '浏览和搜索绝大多数内容无需注册。只有当你希望点赞、评论或发布自己的看料心得时，才需要注册一个账号，注册过程很简单，几分钟即可完成。',
  },
  {
    q: '社区对讨论内容有什么约定？',
    a: '我们希望讨论真实、友善、有料。请大家分享自己的真实感受，尊重不同观点，不做人身攻击，不发布与主题无关的灌水或广告内容。详细规则可在发布前查看社区公约。',
  },
  {
    q: '如何让我的看料心得被更多人看到？',
    a: '内容越具体越容易被回应。可以结合真实经历，给出清晰的分类与标题，适当配图，并在文末提出想和大家讨论的问题。高质量的看料心得会被收录进「心得精选」推荐给更多料友。',
  },
  {
    q: '遇到不合适的内容应该怎么办？',
    a: '每条内容都设有举报入口。收到举报后，社区运营人员会尽快核实并处理。我们依靠每一位料友共同维护友善的互动氛围。',
  },
];

export const guideSteps = [
  {
    icon: 'ri-user-add-line',
    title: '注册并完善档案',
    desc: '花两分钟注册账号，选一个感兴趣的领域，让同好更容易找到你。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '从看料开始',
    desc: '先逛一逛热门话题与心得精选，了解大家正在聊什么，找到想参与的内容。',
  },
  {
    icon: 'ri-chat-smile-3-line',
    title: '大胆交流互动',
    desc: '在评论区留下你的真实感受，或给认同的心得点个赞，互动氛围会越来越好。',
  },
  {
    icon: 'ri-edit-2-line',
    title: '发布你的心得',
    desc: '把经验整理成一篇帖子分享出来，无论新手老手，每一次真诚分享都有价值。',
  },
];